// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let Tooltip = require("./Tooltip.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let ReactDOMStyle = require("@rescript/react/src/ReactDOMStyle.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function RelativeDateLabel(props) {
  let date = props.date;
  let lineClamp = props.lineClamp;
  let __className = props.className;
  let __as_ = props.as_;
  let as_ = __as_ !== undefined ? __as_ : "span";
  let className = __className !== undefined ? __className : "";
  let clampClass = lineClamp !== undefined ? "overflow-hidden" : "";
  let className$1 = TailwindMerge.twMerge([
    "text-sm",
    "text-zinc-500",
    clampClass,
    className
  ]);
  let style = lineClamp !== undefined ? ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp({
      display: "-webkit-box",
      wordBreak: "break-word"
    }, "-webkit-line-clamp", lineClamp.toString()), "-webkit-box-orient", "vertical") : undefined;
  let text = Utils.$$String.capitalize(DateFns.formatDistance(UTCDate.toUnzonedDate(date), new Date()) + " ago");
  return JsxRuntime.jsx(Tooltip.make, {
    label: DateFns.format(UTCDate.toUnzonedDate(date), "MM/dd/yyyy h:mma"),
    children: as_ === "div" ? JsxRuntime.jsx("div", {
        children: text,
        className: className$1,
        style: style
      }) : JsxRuntime.jsx("span", {
        children: text,
        className: className$1,
        style: style
      })
  });
}

let make = RelativeDateLabel;

exports.make = make;
/* Utils Not a pure module */
